<script >
import { ref, onBeforeMount, computed } from 'vue-demi';
import { Rank } from '@fegobull/common-component';
import { PLATFORM_TYPE } from '../common/scheme';
import useCustomRank from './useCustomRank';
import useMarketRank from './useMarketRank';
import useChartData from './useChartData';
import useSelectStatus from './useSelectStatus';
import useRankCmp from './useRankCmp';
import useRankByCard from './useRankByCard';
import useWchNum from './useWchNum';
import useUpDownColor from './useUpDownColor';
import { ADD_ALL_BUTTON_POSITION } from '../common/enum';
const __sfc_main = {};
__sfc_main.props = {
  theme: String,
  rankType: String,
  sort_id: [String, Number],
  showHeader: Boolean,
  increaseType: String,
  market: String,
  upDownColor: Number,
  language: Number,
  count: Number,
  customStocklist: Array,
  schemeType: String,
  platform: {
    type: String,
    default: PLATFORM_TYPE.MOOMOO
  },
  // v2503 增加对接特色榜单的卡片id，增加配置项
  cardId: [String, Number],
  showAddAll: {
    default: true,
    type: Boolean
  },
  showRankTag: {
    default: true,
    type: Boolean
  },
  showTrend: {
    default: false,
    type: Boolean
  },
  showIncrease: {
    default: true,
    type: Boolean
  },
  showAddWch: {
    default: true,
    type: Boolean
  },
  showAddWchCount: {
    default: true,
    type: Boolean
  },
  tagString: {
    default: '',
    type: String
  },
  // 自定义类型的排序类型处理
  sortType: {
    default: 'default',
    type: String
  },
  // 全部添加按钮布局配置
  addAllPosition: {
    default: ADD_ALL_BUTTON_POSITION.RIGHT,
    type: String
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    useEnv
  } = require('@fegobull/webapi').use;
  const {
    isPreRender
  } = useEnv();
  const props = __props;

  // 定义一个股票列表
  const stockList = ref([]);

  // 是否展示
  const isShow = computed(() => stockList.value.length > 0);

  /* 市场排行 */
  const {
    getMarketRank
  } = useMarketRank(props);

  /* 自定义排行 */
  const {
    isCustomRank,
    getCustomRank
  } = useCustomRank(props);

  /* 图表数据 */
  const {
    initChartData,
    chartDataMap
  } = useChartData(stockList, props.increaseType);

  /** 添加自选数量 */
  const {
    initWchNum,
    wchNumMap
  } = useWchNum(props, stockList);

  /* 自选状态 */
  const {
    selfSelectedMap,
    initSelectStatus,
    setSelectStatus,
    addAll
  } = useSelectStatus(props, stockList, wchNumMap);

  /* 组件配置 */
  const {
    headerConfig,
    columnConfig,
    itemClick,
    iconClick,
    addAllConfig,
    addAllClick,
    tagMap
  } = useRankCmp(props, {
    setSelectStatus,
    addAll
  });

  /* 通过通用榜单协议，通过 cardId 获取对应的榜单 */
  const {
    isRankByCard,
    getRankByCard
  } = useRankByCard(props);
  const {
    calcUpDownColor
  } = useUpDownColor(props);
  onBeforeMount(async () => {
    if (isPreRender) {
      return;
    }
    if (isCustomRank.value) {
      stockList.value = await getCustomRank();
    } else if (isRankByCard.value) {
      stockList.value = await getRankByCard();
    } else {
      stockList.value = await getMarketRank();
    }
    props.showTrend && initChartData();
    props.showAddWch && initSelectStatus();
    props.showAddWch && props.showAddWchCount && initWchNum();
  });
  return {
    stockList,
    isShow,
    chartDataMap,
    wchNumMap,
    selfSelectedMap,
    headerConfig,
    columnConfig,
    itemClick,
    iconClick,
    addAllConfig,
    addAllClick,
    tagMap,
    calcUpDownColor
  };
};
__sfc_main.components = Object.assign({
  Rank
}, __sfc_main.components);
export default __sfc_main;
</script>
<template>
    <div class="quote-rank-v2" v-show="isShow">
        <Rank
            :dataSource="stockList"
            :chartDataMap="chartDataMap"
            :selfSelectedMap="selfSelectedMap"
            :wchNumMap="wchNumMap"
            :header="headerConfig"
            :upDownColor="calcUpDownColor"
            :theme="theme"
            @itemClick="itemClick"
            @iconClick="iconClick"
            :addAllConfig="addAllConfig"
            @addAllClick="addAllClick"
            :columnConfig="columnConfig"
            :tagMap="tagMap"
            :addAllPosition="addAllPosition"
        />
    </div>
</template>
<style lang="less" scoped>
.quote-rank-v2 {
    height: auto !important;
    overflow: visible !important;
}
</style>
